{
  "label": "Ilmoitukset",
  "arrear": "Maksuja myöhässä",
  "contract_termination_request_approval_needed": {
    "title": "Sopimus irtisanottu",
    "content": "Hyväksy tai hylkää muutos",
    "rightOfOccupancyNoticeTitle": "Luovutusilmoitus tehty"
  },
  "contract_termination_request_tenant_rejected": "Irtisanominen on peruuntunut, koska kaikki osapuolet eivät hyväksyneet sitä.",
  "contract_termination_request_kenno_rejected": "Irtisanominen on hylätty. Saat lisätietoja sähköpostilla.",
  "message": "Sinulle on uusi viesti",
  "viewMessages": "Näytä viestit",
  "contract_modification_request_approval_needed": {
    "title": "Asukas irtisanoutunut",
    "content": "Hyväksy tai hylkää muutos"
  }
}
